var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-more-page"},[(_vm.nomore)?_c('li',[_vm._v("加载中...")]):_c('li',[_vm._v("没有更多了...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }